export default {
  getPurchaseOrderLine: (state) => state.purchaseOrderLine,
};
